import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TextbookActionGroup } from '@textbook-api-client/lib/interface/textbook-action-group.model';

@Component({
  selector: 'txtb-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaginatorComponent implements OnInit {
  @Input() subSectionLength = 0;
  @Input() activeElement = 1;
  @Input() subPointsShown = true;
  @Input() actionId = '';
  @Input() group?: TextbookActionGroup;

  @Output() changeElement = new EventEmitter<number>();

  handleChange(direction: -1 | 1): void {
    if (this.activeElement === 1 && direction === -1) {
      this.activeElement = this.subSectionLength + 1;
    }
    if (this.activeElement === this.subSectionLength && direction === 1) {
      this.activeElement = 0;
    }
    this.activeElement = this.activeElement + direction;

    this.changeElement.emit(this.activeElement);
  }

  ngOnInit(): void {}
}
